<template>
  <crud-create :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @create="create"
               @close="$emit('close')"
               fullscreen
  >
    <surveys-form ref="form" v-model="form" :input-errors="inputErrors" :alertError="alertError" @save="create"/>
  </crud-create>
</template>

<script>

import SurveysProvider from "../../../../providers/SurveysProvider";

import {CrudCreate, ClientError} from '@dracul/common-frontend'

import SurveysForm from "../../../../forms/SurveysForm";


export default {
  name: "SurveysCreate",

  components: {SurveysForm, CrudCreate},

  props: {
    open: {type: Boolean, default: true}
  },

  data() {
    return {
      title: 'delivery.surveys.creating',
      errorMessage: '',
      inputErrors: {},
      alertError: {
        show: false,
        message: '',
        color: 'error'
      },
      loading: false,
      form: {
        name: '',
        description: '',
        questions: []
      }
    }
  },

  methods: {
    create() {
      if (this.validate()) {
        this.loading = true
        SurveysProvider.createSurvey({
          name: this.form.name,
          description: this.form.description,
          questions: this.form.questions.map(q => ({
            question: q.question,
            isFreeResponse: q.isFreeResponse,
            options: q.options
          }))
        }).then(r => {
              if (r) {
                this.$emit('itemCreated', r.data.createPromo)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    },
    validate(){
      if(!this.$refs.form.validate()) return false
      if(!this.form.questions.length) {
        this.alertError.show = true
        this.alertError.message = 'Debe agregar al menos una pregunta'
        this.alertError.color = 'error'
        return false
      }

      for(const question of this.form.questions) {
        if(!question.isFreeResponse){
          if(!question.question){
            this.alertError.show = true
            this.alertError.message = 'Las preguntas deben tener un valor de pregunta.'
            this.alertError.color = 'error'
            return false
          }
          if(question.options.length < 2){
            this.alertError.show = true
            this.alertError.message = 'Las preguntas cerradas deben tener al menos 2 opciones.'
            this.alertError.color = 'error'
            return false
          }
          for(const option of question.options){
            if(!option.value){
              this.alertError.show = true
              this.alertError.message = 'Las opciones deben tener un valor.'
              this.alertError.color = 'error'
              return false
            }
          }
        }
      }
      return true
    }

  },

  mounted(){
    if(this.$refs.form) this.validate()
  }
}
</script>

<style scoped>

</style>

